<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container>
    <DialogDeleteItem ref="dlgDelete" @doDelete="doDelete"></DialogDeleteItem>
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
        v-model="search"
        append-icon="search"
        label="Suche"
        single-line
        hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
      :headers="headers"
      hide-default-footer
      :items-per-page="-1"
      :items="deviceList"
      :search="search"
      >

        <template v-slot:item.allowed="{ item }">
          <span>
            <v-checkbox outlined v-model="item.allowed" class="mx-2" label="Zugeteilt" @change="changeRight(item)"></v-checkbox>
          </span>
        </template>

        <template v-slot:item.name="{ item }">
          <span>
            {{item.name}}
          </span>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import Vue from 'vue'
import DialogDeleteItem from "../dialogs/DialogDeleteItem";

export default {
  name: 'TableRechte',
  props: {
    showTitle: Boolean,
    companyId: String,
    roleId: String
  },
  components: {DialogDeleteItem},
  methods: {
    deleteItem: function (item) {
      this.$refs.dlgDelete.open({
        type: 'Recht',
        id: '' + item.guid,
        name: 'Recht ' + item.username,
        item: item
      })
    },
    doDelete: function (item) {
      console.log('item', item)
      Vue.prototype.$apiRight.deleteItem(item.item.guid, this.reload)
    },
    editItem: function (item) {
      if (this.companyId) {
        this.$router.push('/Netzwerke/' + this.companyId + '/Benutzer/' + item.guid)
      } else {
        this.$router.push('/Benutzer/' + item.guid)
      }
    },
    changeRight: function (item) {
      console.log('changeRight', item)
      var up = {
        guid: item.guid,
        allowed: item.allowed
      }
      Vue.prototype.$apiRight.updateRight(up, this.reload)
    },
    reload: function () {
      var reqData = {}
      if (this.roleId != null) {
        reqData.guidParent = this.roleId
      }
      Vue.prototype.$apiRight.loadRights(reqData, this.onGetData)
    },
    onGetData: function (result) {
      console.log('result', result)
      this.deviceList = result
    }
  },
  data () {
    return {

      currentDevice: null,
      search: null,
      headers: [
        {text: 'Erlaubt', align: 'left', value: 'allowed'},
        {text: 'Name', align: 'left', value: 'name'},
        {text: 'Gruppe', value: 'groupName'},
        {text: 'Beschreibung', value: 'comment'}
      ],
      deviceList: []
    }
  },
  mounted () {
    var cmp = this
    this.$nextTick(() => {
      cmp.reload()
    })

  }
}
</script>

<style scoped>

</style>
